
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kgw3S", function(module, exports) {

$parcel$export(module.exports, "WatchDialogUnwatchContentMutation", () => $ec0e2c0a72dff83b$export$2018e5f67b7f2d76);

var $d2LG0 = parcelRequire("d2LG0");
const $ec0e2c0a72dff83b$export$2018e5f67b7f2d76 = (0, $d2LG0.default)`mutation WatchDialogUnwatchContentMutation($id:ID!){unwatchContent(watchContentInput:{contentId:$id currentUser:true}){content{id currentUserIsWatching}}}`;

});

parcelRegister("kcnoC", function(module, exports) {

$parcel$export(module.exports, "ContentType", () => $4eb3d231e333e039$export$e2e108cbe2e4f865);
var $4eb3d231e333e039$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["PAGE"] = "page";
    ContentType["BLOG"] = "blogpost";
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["DATABASE"] = "database";
    return ContentType;
}({});

});


//# sourceMappingURL=WatchDialogContent.08e80e22.js.map
